// src/api/utilityApi.js
import axiosClient from "./axiosClient";

//Create a new utility
export const createUtility = async (data) => {
  return axiosClient.post("/utilities/create/", data);
};

//Update an existing utility
export const updateUtility = async (utilityId, data) => {
  return axiosClient.put(`/utilities/${utilityId}/update/`, data);
};

//Delete a utility
export const deleteUtility = async (utilityId) => {
  return axiosClient.delete(`/utilities/${utilityId}/delete/`);
};

//Fetch property or unit details (including utilities)
export const getUtilityParentDetails = async (propertyId, unitId) => {
  const endpoint = unitId
    ? `/units/${unitId}/details/`
    : `/properties/${propertyId}/details/`;
  const res = await axiosClient.get(endpoint);
  return res.data;
};